import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { ScanMode } from '@/models/Scan'
import Login from '@/views/Login/Login.vue'
import LoggedInArea from '@/views/LoggedInArea/LoggedInArea.vue'
import Home from '@/views/Home/Home.vue'
import MoveContainer from '@/views/MoveContainer/MoveContainer.vue'
import MoveContainerRoom from '@/views/MoveContainer/views/Room.vue'
import MoveContainerContainer from '@/views/MoveContainer/views/Container.vue'
import MoveContainerAssigned from '@/views/MoveContainer/views/Assigned.vue'
import MoveContainerAwaitingWeighing from '@/views/MoveContainer/views/AwaitingWeighing.vue'
import WeighContainer from '@/views/WeighContainer/WeighContainer.vue'
import WeighContainerScan from '@/views/WeighContainer/views/Scan.vue'
import WeighContainerManual from '@/views/WeighContainer/views/Manual.vue'
import WeighContainerAssigned from '@/views/WeighContainer/views/Assigned.vue'
import WeighContainerWeighted from '@/views/WeighContainer/views/Weighted.vue'
import WeighContainerUnknown from '@/views/WeighContainer/views/Unknown.vue'
import AddContainer from '@/views/AddContainer/AddContainer.vue'
import AddContainerType from '@/views/AddContainer/views/Type.vue'
import AddContainerScan from '@/views/AddContainer/views/Scan.vue'
import AddContainerRoom from '@/views/AddContainer/views/Room.vue'
import ReportIncident from '@/views/ReportIncident/ReportIncident.vue'
import ReportIncidentType from '@/views/ReportIncident/views/Type.vue'
import ReportIncidentScan from '@/views/ReportIncident/views/Scan.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ top: 0 })
      }, 250)
    })
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      meta: {
        requiresAuth: true,
      },
      component: LoggedInArea,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: 'move-container',
          component: MoveContainer,
          children: [
            {
              path: '',
              name: 'move-container',
              redirect: { name: 'move-container-room' },
            },
            {
              path: 'room',
              name: 'move-container-room',
              component: MoveContainerRoom,
            },
            {
              path: 'container',
              name: 'move-container-container',
              component: MoveContainerContainer,
            },
            {
              path: 'assigned',
              name: 'move-container-assigned',
              component: MoveContainerAssigned,
            },
            {
              path: 'awaiting-weighing',
              name: 'move-container-awaiting-weighing',
              component: MoveContainerAwaitingWeighing,
            },
          ],
        },
        {
          path: 'weigh-container',
          component: WeighContainer,
          children: [
            {
              path: '',
              name: 'weigh-container',
              redirect: { name: 'weigh-container-scan' },
            },
            {
              path: 'scan',
              name: 'weigh-container-scan',
              component: WeighContainerScan,
            },
            {
              path: 'manual',
              name: 'weigh-container-manual',
              component: WeighContainerManual,
            },
            {
              path: 'assigned',
              name: 'weigh-container-assigned',
              component: WeighContainerAssigned,
            },
            {
              path: 'weighted',
              name: 'weigh-container-weighted',
              component: WeighContainerWeighted,
            },
            {
              path: 'unknown/:code',
              name: 'weigh-container-unknown',
              component: WeighContainerUnknown,
              props: true,
            },
          ],
        },
        {
          path: 'add-container',
          component: AddContainer,
          children: [
            {
              path: '',
              name: 'add-container',
              redirect: { name: 'add-container-type' },
            },
            {
              path: 'type',
              name: 'add-container-type',
              component: AddContainerType,
            },
            {
              path: 'scan',
              name: 'add-container-scan',
              component: AddContainerScan,
            },
            {
              path: 'room',
              name: 'add-container-room',
              component: AddContainerRoom,
            },
          ],
        },
        {
          path: 'report-incident',
          component: ReportIncident,
          children: [
            {
              path: '',
              name: 'report-incident',
              redirect: { name: 'report-incident-type' },
            },
            {
              path: 'type',
              name: 'report-incident-type',
              component: ReportIncidentType,
            },
            {
              path: 'scan',
              name: 'report-incident-scan',
              component: ReportIncidentScan,
            },
          ],
        },
      ],
    },
  ],
})

// Redirect to login if needed
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const userStore = useUserStore()
    if (userStore.isAuthenticated) {
      next()
    } else {
      next({ name: 'login' })
    }
  } else {
    next()
  }
})

export default router
